import { ReferenceArrayInput, SelectArrayInput } from "react-admin";
import { SchoolIdSelected } from "../../../utils/tools";
import { useField } from "react-final-form";

const BusScheduleInput = () => {
  const schoolIdSelected = SchoolIdSelected();

  const schoolIdField = useField("schoolId");

  return (
    <ReferenceArrayInput
      source="busScheduleIds"
      reference="busSchedules"
      filter={{ SchoolId: schoolIdSelected }}
      perPage={9999}
      sort={{ field: "name", order: "ASC" }}
      onChange={() => {
        schoolIdField.input.onChange(schoolIdSelected);
      }}
    >
      <SelectArrayInput optionText="name" />
    </ReferenceArrayInput>
  );
};

export default BusScheduleInput;
